import React, { Fragment, useContext } from 'react'
import { LangEum } from '@/constant'
import classnames from 'classnames'
import { CouponInfoModleItemType } from '../../types'
import Context from '../../context'
import styles from '../../index.module.less'

function CouponItem(props: { data: CouponInfoModleItemType; isSell: boolean }) {
  const { currencyCode, noSill, fullReduct, getMoney, lang, packageMail } = useContext(Context)
  const { data, isSell } = props
  const { deductionAmount, couponType, limitAmount, useLimit } = data
  return (
    <div
      className={classnames({
        [styles['buy-item']]: true,
        [styles[`buy-item-${lang}`]]: true,
      })}
    >
      <div className={styles['buy-item-top']}>
        {couponType == 1 ? (
          <Fragment>
            <span className={styles['buy-item-money-sign']}>{currencyCode}</span>
            <span className={styles['buy-item-money']}>{getMoney(deductionAmount)}</span>
            {lang === LangEum.en && useLimit === 2 && !isSell && (
              <span
                className={classnames({
                  [styles['buy-item-money-sign']]: true,
                  [styles['buy-item-money-sign-off']]: true,
                })}
              >
                Off
              </span>
            )}
          </Fragment>
        ) : (
          <span className={classnames({
            [styles['toups-title']]: true,
            [styles['toups-title-en']]: lang === LangEum.en
          }) }>{packageMail}</span>
        )}
      </div>
      <div className={styles['buy-item-condition']}>
        {useLimit === 1 ? noSill : fullReduct(limitAmount, currencyCode)}
      </div>
    </div>
  )
}

function CouponLine(props: { data: CouponInfoModleItemType[]; isSell: boolean }) {
  const { data, isSell } = props

  return (
    <div className={styles['buy-line']}>
      {data.map((ele, i) => {
        return <CouponItem isSell={isSell} data={ele} key={`${i}`} />
      })}
    </div>
  )
}

export default CouponLine
